<template>
  <div class="layout">
    <div class="tagImg" :style="{backgroundImage:`url(${img})`}">
      <div class="text">
        <p class="text1">最感兴趣的栏目</p>
        <p class="text2">定制专属于我的直播栏目</p>
      </div>
    </div>
    <div class="btnBox">
      <mt-button class="btn" type="default" v-for="item in dataList" :key="item.id">{{item.name}}</mt-button>
    </div>
    <div class="goIndex" @click="goIndex">进入首页>></div>
  </div>
</template>

<script>
export default {
  name: 'Layout',
  data() {
    return {
      img: require('../assets/img/tag.png'),
      dataList: []
    }
  },
  components: {},
  created() {},
  mounted() {
    this.initData()
    this.noShare()
  },
  methods: {
    initData() {
      this.dataList = [
        {
          id: '001',
          name: '心血管'
        },
        {
          id: '002',
          name: '骨科'
        },
        {
          id: '003',
          name: '脑肿瘤'
        },
        {
          id: '004',
          name: '精神心理'
        },
        {
          id: '005',
          name: '内分泌代谢'
        },
        {
          id: '006',
          name: '神经'
        },
        {
          id: '007',
          name: '皮肤'
        },
        {
          id: '008',
          name: '妇产科'
        }
      ]
    },
    goIndex() {
      this.$router.push('/')
    }
  }
}
</script>
<style lang='scss' scoped>
.layout {
  width: 100%;
  height: 100%;
  padding: 20px 10px;
  box-sizing: border-box;
  .tagImg {
    background-size: 100% 100%;
    height: 140px;
    background-repeat: no-repeat;
    margin: 5rem 0 4rem 0;
    position: relative;
    .text {
      position: absolute;
      top: 56px;
      left: 25%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .text1 {
        color: $theme-color;
        font-size: 2.4rem;
        font-weight: 600;
      }
      .text2 {
        color: #888888;
        margin-top: 6px;
        font-size: 1.8rem;
      }
    }
  }
  .btnBox {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    .btn {
      margin: 6px 12px;
    }
  }
  .goIndex {
    text-align: center;
    color: $theme-color;
    margin-top: 36px;
  }
}
</style>
